/**
 * Created by Jerker Nord on 2020-05-07.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Timeline, TimelineLite} from "gsap";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BonusBunniesBitmapCountUp} from "./BonusBunniesBitmapCountUp";

export class BonusBunniesBitmapWinCountUp extends BaseView {

    private readonly _style:BitmapTextStyleOptions;
    protected _countUp:BonusBunniesBitmapCountUp;
    protected _countUpContainer:PIXI.Sprite;

    constructor(style:BitmapTextStyleOptions) {
        super();

        this._style = style;
    }

    protected initAnimations():void {
        this._countUp = new BonusBunniesBitmapCountUp({
            style : this._style
        });
        this._countUp.shrinkSize = true;
        this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp.visible = false;

        // To use an extra container to make scale animations. the countUp has it's own scale calculation in animationConfig.
        this._countUpContainer = new PIXI.Sprite();
        this._countUpContainer.anchor.set(0.5, 0.5);
        this._countUpContainer.addChild(this._countUp);

        this.addChild(this._countUpContainer);
    }

    public abort(endValue:number, isAborted:boolean, ...params:any[]):Timeline | null {
        const timeline:TimelineLite = new TimelineLite();
        if(isAborted) {
            timeline.add(this.getAbortAnimation(endValue, ...params));
        }
        timeline.add(this.getEndingAnimation(endValue, ...params));

        return timeline;
    }

    public getCountUpAnimation(playSound:boolean, from:number, to:number, duration:number, ...params:any[]):Timeline {
        return new TimelineLite();
    }

    public getEndingAnimation(endValue:number, ...params:any[]):Timeline {
        return new TimelineLite();
    }

    protected getAbortAnimation(endValue:number, ...params:any[]):Timeline {
        return new TimelineLite();
    }
}